import { createRouter, createMemoryHistory} from 'vue-router'
import PageOne from "@/components/system/PageOne";
import PageTwo from "@/components/system/PageTwo";
import PageThree from "@/components/system/PageThree";
import PageFour from "@/components/system/PageFour";
import DataMonitor from "@/components/DataMonitor";
import LoginView from "@/components/LoginView";
import RefreshView from "@/components/RefreshView";
import ChartView from "@/components/utils/ChartView";
import PowerCount from "@/components/PowerCount";
import EventRecord from "@/components/EventRecord";

const routes = [
    {path: '/', component: PageOne},
    {path: '/1', component: PageOne},
    {path: '/2', component: PageTwo},
    {path: '/3', component: PageThree},
    {path: '/4', component: PageFour},
    {path: '/7', component: DataMonitor},
    {path: '/7-1', component: ChartView},
    {path: '/8', component: PowerCount},
    {path: '/9', component: EventRecord},
    {path: '/login', component: LoginView},
    {path: '/refresh', component: RefreshView, beforeEnter: (_, from) => {router.replace(from.fullPath)}},
]
const router = createRouter({
    history: createMemoryHistory(),
    routes,
})
export default router